

















































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import PayrollRunStatus from '@/models/Payroll/PayrollRunStatus';
import {
    PayrollRunDetailsModule,
    PayrollRunLocationSummary,
} from '@/store/modules/payrollRunDetails';

@Component({
    name: 'PayrollRunLocations',
})
export default class extends GiganautVue {
    @Prop({ required: true }) runId!: string;
    @Prop({ required: true }) runStatus!: number;
    @Prop({ default: '' }) providerName!: string;

    activeTab = 0;

    newHeaders = [
        { text: this.Labels.location, value: 'brandName', sortable: false },
        { text: 'Timesheets (sent/bound)', value: 'sentTimesheetCount', align: 'end', sortable: false, width: 170 },
        { text: 'Last error', value: 'customerSyncError', sortable: false },
    ];

    existingHeaders = [
        { text: this.Labels.location, value: 'brandName', sortable: false },
        { text: 'Timesheets (sent/bound)', value: 'sentTimesheetCount', align: 'end', sortable: false, width: 170 },
        { text: 'Payroll reference', value: 'externalPayrollSystemId', sortable: false },
    ];

    get saving(): boolean { return PayrollRunDetailsModule.saving; }
    get locationsLoading(): boolean { return PayrollRunDetailsModule.locationsLoading; }
    get locations(): PayrollRunLocationSummary[] { return PayrollRunDetailsModule.locations; }

    get newLocations(): PayrollRunLocationSummary[] {
        return this.locations.filter(l => !l.customerSyncedAt);
    }

    get existingLocations(): PayrollRunLocationSummary[] {
        return this.locations.filter(l => !!l.customerSyncedAt);
    }

    // Sync only allowed while the run is editable. Once submitted, the run
    // is locked from customer pushes.
    get canSend(): boolean {
        return this.runStatus === PayrollRunStatus.Draft || this.runStatus === PayrollRunStatus.Submitting;
    }

    get providerLabel(): string {
        return this.providerName || 'payroll system';
    }

    @Watch('runId', { immediate: true })
    async onRunIdChange(newVal: string) {
        if (!newVal) return;
        await PayrollRunDetailsModule.ensureLocationsLoaded(newVal);
    }

    async onSend() {
        await PayrollRunDetailsModule.ensureCustomers(this.runId);
    }
}
